import React, { useState } from 'react';
import { BillConceptTax, FiscalpopImpuesto } from '../../../models/Factura';
import Input from '../../Forms/Input';
import Button from '../../Forms/Button';
import Select from '../../Forms/Select';

export function ConceptoElementImpuesto({ i, impuesto, impuestosList, handleImpuestoUpdate, handleAddNewTax, handleRemoveTax }: { i: number, handleAddNewTax: () => void, handleRemoveTax: (index: number) => (_: any) => void, impuesto: BillConceptTax, impuestosList: FiscalpopImpuesto[], handleImpuestoUpdate: (i: number) => (update: BillConceptTax) => void }) {
    const [isRange, setIsRange] = useState(false);
    const [rangeParams, setRangeParams] = useState([0, 16]);

    const handleImpuestoChange = (index: number, property: 'type' | 'retencion' | 'tasa' | 'cuota') => (value: any) => {
        const assigner: { [key: string]: any } = {};
        assigner[property] = value;
        const currentImpuesto = impuesto;
        if (property === 'type') {
            if (currentImpuesto.type !== value) {
                // Type changed, reset options
                if (value === 'iva') {
                    assigner['retencion'] = false;
                    assigner['tasa'] = 0.16;
                }
                if (value === 'ieps') {
                    assigner['retencion'] = false;
                    assigner['tasa'] = 0.03;
                }
                if (value === 'isr') {
                    assigner['retencion'] = true;
                    assigner['tasa'] = 0.35;
                }
            }
        }
        if (property === 'retencion') {
            if (currentImpuesto.retencion !== value) {
                const valueOption = impuestoValueOptions(currentImpuesto.type, value)[0];
                if (valueOption.isRange) {
                    if (valueOption.factor === 'Cuota') {
                        assigner['cuota'] = valueOption.value;
                        assigner['tasa'] = null;
                    } else {
                        assigner['tasa'] = valueOption.value;
                        assigner['cuota'] = null;
                    }
                    // Open Range options state
                    setIsRange(true);
                    setRangeParams([valueOption.valueMin, valueOption.value]);
                } else {
                    if (valueOption.factor === 'Cuota') {
                        assigner['cuota'] = valueOption.value;
                        assigner['tasa'] = null;
                    } else {
                        assigner['tasa'] = valueOption.value;
                        assigner['cuota'] = null;
                    }
                    // Close Range options state
                    setIsRange(false);
                }
            }
        }
        if (property === 'tasa') {
            assigner['cuota'] = null;
            if (isRange && value > rangeParams[1]) {
                assigner['tasa'] = rangeParams[1];
            } else if (isRange && value < rangeParams[0]) {
                assigner['tasa'] = rangeParams[0];
            }
        }
        if (property === 'cuota') {
            assigner['tasa'] = null;
            if (isRange && value > rangeParams[1]) {
                assigner['cuota'] = rangeParams[1];
            } else if (isRange && value < rangeParams[0]) {
                assigner['cuota'] = rangeParams[0];
            }
        }
        const _impuesto: BillConceptTax = Object.assign({}, currentImpuesto, assigner);
        handleImpuestoUpdate(i)(_impuesto);
    }

    const handleImpuestoChangeValue = (index: number) => (value: number) => {
        // Check if this is tasa or cuota
        const currentImpuesto = impuesto;
        const valueOptions = impuestoValueOptions(currentImpuesto.type, currentImpuesto.retencion);
        const candidate = valueOptions.find(vO => vO.value === value);
        if (candidate.factor === 'Cuota') {
            handleImpuestoChange(index, 'cuota')(candidate.value)
        } else {
            handleImpuestoChange(index, 'tasa')(candidate.value)
        }
        console.log('Candidate change value: ', candidate);
        if (candidate.isRange) {
            // Open isRange here
            setIsRange(true);
            setRangeParams([candidate.valueMin, candidate.value]);
        } else {
            setIsRange(false);
        }
    }

    const impuestoTypeOptions = () => {
        const impuestosSet = new Set(impuestosList.map(iL => iL.impuesto));
        const options: { value: string, label: string }[] = [];
        for (const [e] of impuestosSet.entries()) {
            options.push({ value: e.toLowerCase(), label: e })
        }
        return options;
    }

    const impuestoTranslateOptions = (type: 'iva' | 'ieps' | 'isr') => {
        const _type = type.toUpperCase()
        const candidates = impuestosList.filter(iL => iL.impuesto === _type)
        const options: { value: boolean, label: string }[] = [];
        if (candidates.some(c => c.traslado)) {
            options.push({ value: false, label: 'Traslado' })
        }
        if (candidates.some(c => c.retencion)) {
            options.push({ value: true, label: 'Retención' })
        }
        return options;
    }

    const impuestoValueOptions = (type: 'iva' | 'ieps' | 'isr', retencion: boolean) => {
        const _type = type.toUpperCase()
        const candidates = impuestosList.filter(iL => iL.impuesto === _type).filter((iL) => {
            if (!retencion && iL.traslado) {
                return true;
            }
            else if (retencion && iL.retencion) {
                return true;
            } else {
                return false;
            }
        });
        const options = candidates.map((tax) => ({ value: tax.max, valueMin: tax.tipo === 'Rango' ? (tax.min || 0) : null, isRange: tax.tipo === 'Rango', factor: tax.factor, label: tax.factor === 'Cuota' ? `$ ${tax.min !== null ? tax.min + ' - ' : ''}${tax.max} / unidad` : tax.min !== null ? `${(tax.min * 100).toFixed(1)} - ${(tax.max * 100).toFixed(1)}%` : `${(tax.max * 100).toFixed(1)} %` }))
        return options;
    }
    return (
        <div className="impuesto">
            <i className="material-icons delete" onClick={handleRemoveTax(i)}>
                delete
                            </i>
            <div className="row five md-four sm-two xs-gap-compressed" key={i}>
                <Select label="Impuesto" value={impuesto.type} options={impuestoTypeOptions()} onChange={handleImpuestoChange(i, 'type')} />
                <Select label="Traslado / Retencion" value={impuesto.retencion} options={impuestoTranslateOptions(impuesto.type)} onChange={handleImpuestoChange(i, 'retencion')} />
                <Select label="Valor del impuesto" value={isRange ? rangeParams[1] : impuesto.tasa || impuesto.cuota} options={impuestoValueOptions(impuesto.type, impuesto.retencion)} onChange={handleImpuestoChangeValue(i)} />
                {
                    isRange ?
                        (
                            impuesto.tasa !== null ?
                                <Input type="number" label={`Valor de la tasa`} placeholder="" value={impuesto.tasa} onChange={handleImpuestoChange(i, 'tasa')} min={rangeParams[0]} max={rangeParams[1]} step={0.01} />
                                :
                                <Input type="number" label={`Valor de la cuota`} placeholder="" value={impuesto.cuota} onChange={handleImpuestoChange(i, 'cuota')} min={rangeParams[0]} max={rangeParams[1]} step={0.01} />
                        )
                        : <div></div>
                }
                {
                    <Button secondary={true} handleClick={handleAddNewTax}>
                        <span>Agregar otro impuesto</span>
                    </Button>
                }
            </div>
        </div>
    )
}
